import client from '@/lib/http-client';

const endpoint = '/userSubscriptions';

export default {
	checkout(creds, cb, errorCb) {
		const url = `${endpoint}/checkout`;
		client.post(url, creds)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	process(params, cb, errorCb) {
		const url = `${endpoint}/process`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	cancel(params, cb, errorCb) {
		const url = `${endpoint}/cancel`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	activate(params, cb, errorCb) {
		const url = `${endpoint}/switch`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
